<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <nb-card class="form">
    <nb-card-header
      ><h4>
        {{ "dialogs.domainWhitelist.title" | translate }}
      </h4></nb-card-header
    >
    <nb-card-body formArrayName="allowed_domains">
      @for( item of domains; track item ;let i = $index){

      <nb-form-field>
        <input type="text" nbInput [formControlName]="i" />
        <button nbSuffix nbButton ghost (click)="deleteDomain(i)">
          <nb-icon icon="trash-2" pack="eva"> </nb-icon>
        </button>
      </nb-form-field>

      }

      <button
        nbButton
        (click)="addDomain()"
        status="primary"
        ghost=""
        type="button"
        fullWidth="true"
        tabindex="-1"
      >
        {{ "buttons.addDomain" | translate }}
      </button>
    </nb-card-body>

    <nb-card-footer>
      <button
        type="button"
        nbButton
        status="danger"
        outline
        (click)="dialogRef.close()"
      >
        {{ "buttons.cancel" | translate }}
      </button>
      <button type="submit" nbButton status="primary">
        {{ "buttons.save" | translate }}
      </button>
    </nb-card-footer>
  </nb-card>
</form>
